import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";
import router from "@/router";

const notiMessage = new NotiMessage("success");

//presumptive
const allUrl = "refer_patient/get?";
const eachUrl = "refer_patient/getEach?";
const createUrl = "refer_patient/store";
const updateUrl = "refer_patient/update";
const deleteUrl = "refer_patient/delete";
const savePresumptiveUrl = "refer_patient/savePresumptive";

const state = {
  referPresumptiveData: [],
  referPresumptiveDataEach: {},
};
const getters = {
  referPresumptiveDataEach(state) {
    state.referPresumptiveDataEach.sex =
      state.referPresumptiveDataEach.sex + "";
    return state.referPresumptiveDataEach;
  },
};
const mutations = {
  SET_REFER_PRESUMPTIVE_DATA(state, payload) {
    state.referPresumptiveData = payload.data.data;
  },
  APPEND_REFER_PRESUMPTIVE_DATA(state, payload) {
    state.referPresumptiveData.push(payload.data.data);
  },
  SET_REFER_PRESUMPTIVE_DATA_EACH(state, payload) {
    state.referPresumptiveDataEach = payload.data.data;
  },
  REMOVIE_REFER_PRESUMPTIVE_DATA(state, payload) {
    state.referPresumptiveData = state.referPresumptiveData.filter((val) => {
      return val.id != payload;
    });
  },
};

const actions = {
  async save({ commit }, payload) {
    const response = await Request.post_data(createUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("APPEND_REFER_PRESUMPTIVE_DATA", response);
      notiMessage.displayNotiMsg("Presumptive Referral is saved");
      return true;
    }
    return false;
  },
  async edit({ commit }, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("APPEND_REFER_PRESUMPTIVE_DATA", response);
      notiMessage.displayNotiMsg("Presumptive Referral is edited");
      return true;
    }
    return false;
  },
  async deleteReferPatient({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVIE_REFER_PRESUMPTIVE_DATA", payload.id);
      notiMessage.displayNotiMsg("Presumptive Referral is deleted");
      return true;
    }
    return false;
  },
  async saveAsPresumptive({ commit }, payload) {
    console.log(commit);
    const response = await Request.post_data(savePresumptiveUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg(
        "Presumptive Referral is  saved as Presumptive"
      );
      router.back();
    }
    return false;
  },

  async getAll({ commit }, payload) {
    const response = await Request.get_data(allUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_REFER_PRESUMPTIVE_DATA", response);
  },
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_REFER_PRESUMPTIVE_DATA_EACH", response);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
